import { BorderGridContainer, GridBox, H2, TypeWrapper } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';

import { LinkWrapper, StyledClickable, StyledSection } from './styles';
import type { SectionQuickLinks } from '../../pages/insurance/types';

type QuickLinksCustomProps = {
  isBrowserHandled?: boolean;
};

const QuickLinks = ({ title, links, isBrowserHandled = false }: SectionQuickLinks & QuickLinksCustomProps) => {
  if (isEmpty(links)) {
    return null;
  }

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <StyledSection variant={['paddingTopSpacer5', 'paddingBottomSpacer5']}>
          <TypeWrapper variant="center">
            {title ? <H2 variant="marginBottomSpacer8">{title}</H2> : null}
            <LinkWrapper>
              {map(
                (link) =>
                  link.name && link.url ? (
                    <StyledClickable isBrowserHandled={isBrowserHandled} key={JSON.stringify(link)} to={link.url}>
                      {link.name}
                    </StyledClickable>
                  ) : null,
                links,
              )}
            </LinkWrapper>
          </TypeWrapper>
        </StyledSection>
      </GridBox>
    </BorderGridContainer>
  );
};

export default QuickLinks;
